import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import * as styles from "./CardTile.css";
import { CardTile as TCardTile } from "~/sanity/types";
import { Heading } from "~/components/elements/Heading";
import PortableText, {
  IPortableText,
} from "~/components/portableText/PortableText";
import { ButtonLink } from "~/components/elements/ButtonLink";
// @ts-ignore
import ArrowOutward from "@material-design-icons/svg/filled/arrow_outward.svg?react";

export type CardTileProps = ComponentPropsWithoutRef<"div"> &
  PropsWithChildren & { card: TCardTile };

export const CardTile = ({ card, ...props }: CardTileProps) => {
  const { title, text, link } = card;
  return (
    <div className={styles.cardWrapper}>
      <div className={styles.card}>
        <div className={styles.content}>
          <div className={styles.text}>
            <div className={styles.heading}>
              <Heading as="h2" size="h2" uppercase bold>
                {title}
              </Heading>
            </div>
            <PortableText blocks={text as IPortableText} />
          </div>
          {link && link.slug && (
            <div className={styles.buttonContainer}>
              <ButtonLink
                isPrimary={false}
                theme="dark"
                link={link}
                icons={{ iconPrimary: <ArrowOutward /> }}
              >
                {link.text}
              </ButtonLink>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
